import "@/assets/vendor/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@/assets/scss/argon.scss";
import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";
import VueLazyload from "vue-lazyload";

export default {
  install(app) {       // Vue2: Vue → Vue3: app
    app.use(globalComponents);
    app.use(globalDirectives);
    app.use(VueLazyload);
  }
};
